export interface ConsoleConfig {
  /** The control API base, including the `/v1` version prefix. */
  apiBaseUrl: string;
  /** False under the dev server, which sends nothing to Google Analytics. */
  analytics: boolean;
}

export function readConfig(env: ImportMetaEnv): ConsoleConfig {
  const origin = env.VITE_API_URL?.trim();
  if (origin === undefined || origin === "") {
    throw new Error("VITE_API_URL is not set. Set it to the control API origin, for example http://localhost:8787.");
  }
  return {
    apiBaseUrl: `${origin.replace(/\/+$/, "")}/v1`,
    analytics: env.PROD,
  };
}
